/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.container[_ngcontent-%COMP%]{box-shadow:0 2px 5px 0 rgba(0,0,0,.26);padding-left:0;padding-right:0;min-height:calc(100vh - 64px)}.survey[_ngcontent-%COMP%]{padding:0;margin:0}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc2xpcHJlc2lzdGFudC9zbGlwcmVzaXN0YW50L2NsaWVudC9zcmMvYXBwL3BhcnRpY2lwYXRpb24tZm9ybS9wYXJ0aWNpcGF0aW9uLWZvcm0tY2xlYW51cC9wYXJ0aWNpcGF0aW9uLWZvcm0tY2xlYW51cC5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3J1bm5lci93b3JrL3NsaXByZXNpc3RhbnQvc2xpcHJlc2lzdGFudC9jbGllbnQvc3JjL2FwcC9wYXJ0aWNpcGF0aW9uLWZvcm0vcGFydGljaXBhdGlvbi1mb3JtLWNsZWFudXAvcGFydGljaXBhdGlvbi1mb3JtLWNsZWFudXAuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/$$_gendir/app/participation-form/participation-form-cleanup/participation-form-cleanup.component.scss.shim.ngstyle.ts